import './Blankspace.css';
const Blankspace = () => {
  return ( 
    <div className="blankspace">
      {/* <Dashfooter/> */}
    </div>
   );
}
 
export default Blankspace;